import { api } from "@/api";
import {
  DEFAULT_VIRTUAL_SPORT_TYPE,
  VirtualSportType,
  virtualStreamPath,
} from "./virtualSportType";

// Resolve a VR (Sportradar VFL / VBL) video HLS url. A league streams 8 channels (one
// per match of the live round); pass a `matchId` to get that match's channel,
// omit it for channel 0. Returns null for an unknown league.
export const resolveVirtualStream = async (
  leagueId: number,
  matchId?: number,
  sportType: VirtualSportType = DEFAULT_VIRTUAL_SPORT_TYPE
): Promise<string | null> => {
  const res = await api.client.get(virtualStreamPath(sportType, "resolve"), {
    params: matchId ? { leagueId, matchId } : { leagueId },
  });
  return res.data?.url ?? null;
};
